/** ETAPA A — Ayuda del menú de Presupuestos SA: explicación breve de cada sección
 *  en un panel contextual (sin navegar a otra página). */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const SECCIONES_SA = [
  ['Nuevo presupuesto', 'Crea una cotización nueva: cliente, proyecto y elementos.'],
  ['Presupuestos', 'Lista de todas las cotizaciones con su estado, total y vendedor.'],
  ['Catálogo Soluarq', 'Administra los vidrios, herrajes, accesorios, materiales y demás productos utilizados para preparar las cotizaciones.'],
  ['Valores generales', 'Configura valores generales que utilizan las cotizaciones (antes "Variables").'],
  ['Reglas', 'Administra las reglas técnicas utilizadas para calcular las soluciones.'],
  ['Costos de ejecución', 'Agrega mano de obra, flete, viáticos y otros costos relacionados con la instalación.'],
  ['Plantillas', 'Guarda soluciones que utilizas frecuentemente para cotizar más rápido.'],
  ['Empresa / PDF', 'Configura la información y presentación que aparece en las cotizaciones.'],
  ['Configuración', 'Configura opciones generales del módulo.'],
  ['Permisos', 'Define qué usuarios pueden acceder y modificar las diferentes funciones.'],
  ['Ayuda / Manual', 'Consulta cómo utilizar las funciones de Presupuestos SA.'],
];

export const MenuAyudaSA = ({ open, onClose }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="sm:max-w-[520px] max-h-[85vh] overflow-y-auto" aria-describedby={undefined} data-testid="menu-ayuda-sa">
      <DialogHeader><DialogTitle className="text-sm">¿Qué hay en cada sección?</DialogTitle></DialogHeader>
      <div className="space-y-2">
        {SECCIONES_SA.map(([t, d]) => (
          <div key={t} className="border border-[var(--border)] rounded-lg px-3 py-2">
            <p className="text-xs font-black text-[var(--text)]">{t}</p>
            <p className="text-[11px] text-[var(--text-muted)]">{d}</p>
          </div>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);

// Ayuda contextual breve: icono "?" con descripción (funciona con tap en móvil vía title/focus)
export const AyudaTip = ({ texto }) => (
  <span className="inline-flex items-center justify-center w-4 h-4 ml-1 rounded-full border border-[var(--border)] text-[9px] font-black text-[var(--text-muted)] cursor-help align-middle select-none"
    title={texto} role="tooltip" data-testid="ayuda-tip" onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.alert(texto); }}>?</span>
);
